
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.665 5.876H7.292c-.782 0-1.416.634-1.416 1.416v6.372c0 .782.634 1.416 1.416 1.416h6.373c.782 0 1.416-.634 1.416-1.416V7.292c0-.782-.634-1.416-1.416-1.416z"}}),_c('path',{attrs:{"d":"M3.044 10.124h-.708A1.416 1.416 0 01.919 8.708V2.336A1.416 1.416 0 012.336.919h6.372a1.416 1.416 0 011.416 1.417v.708"}})])
          )
        }
      }
    